import {AxiosResponse} from 'axios'
import httpClient from '@/services/httpClient'

const SupportService = {
  getTickets: (): Promise<AxiosResponse<any>> =>
    httpClient.get('/support/tickets'),
  createTicket: (data: {
    subject: string
    message: string
  }): Promise<AxiosResponse<any>> => httpClient.post('/support/tickets', data),
  getTicket: (ticketId: number | string): Promise<AxiosResponse<any>> =>
    httpClient.get(`/support/tickets/${ticketId}`),
  reply: (
    ticketId: number | string,
    message: string
  ): Promise<AxiosResponse<any>> =>
    httpClient.post(`/support/tickets/${ticketId}/reply`, {message}),
}

export default SupportService
